var _path, _mask, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccount = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 19,
  viewBox: "0 0 24 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.4783 4.5C11.4783 6.70997 9.69015 8.5 7.48622 8.5C5.28228 8.5 3.49414 6.70997 3.49414 4.5C3.49414 2.29003 5.28228 0.5 7.48622 0.5C9.69015 0.5 11.4783 2.29003 11.4783 4.5Z",
  stroke: "currentColor"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_4166_22638",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4296 18.25C14.1103 18.25 15.526 16.8373 14.8838 15.2842C14.495 14.3439 13.9252 13.4896 13.2068 12.7699C12.4884 12.0503 11.6355 11.4794 10.6969 11.0899C9.75831 10.7005 8.75231 10.5 7.73635 10.5C6.7204 10.5 5.7144 10.7005 4.77578 11.0899C3.83716 11.4794 2.98431 12.0503 2.26593 12.7699C1.54754 13.4896 0.977683 14.3439 0.588895 15.2842C-0.0533048 16.8373 1.36246 18.25 3.04313 18.25L7.73635 18.25H12.4296Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4296 18.25C14.1103 18.25 15.526 16.8373 14.8838 15.2842C14.495 14.3439 13.9252 13.4896 13.2068 12.7699C12.4884 12.0503 11.6355 11.4794 10.6969 11.0899C9.75831 10.7005 8.75231 10.5 7.73635 10.5C6.7204 10.5 5.7144 10.7005 4.77578 11.0899C3.83716 11.4794 2.98431 12.0503 2.26593 12.7699C1.54754 13.4896 0.977683 14.3439 0.588895 15.2842C-0.0533048 16.8373 1.36246 18.25 3.04313 18.25L7.73635 18.25H12.4296Z",
  stroke: "currentColor",
  strokeWidth: 2,
  mask: "url(#path-2-inside-1_4166_22638)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9625 6C20.9625 7.93383 19.3978 9.5 17.4695 9.5C15.5412 9.5 13.9766 7.93383 13.9766 6C13.9766 4.06617 15.5412 2.5 17.4695 2.5C19.3978 2.5 20.9625 4.06617 20.9625 6Z",
  stroke: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7239 13.6468C22.2451 14.169 22.6588 14.7891 22.941 15.4716C23.0534 15.7435 23.0012 15.978 22.8115 16.1926C22.5992 16.4328 22.2166 16.6246 21.7672 16.6246H17.7555H16.0521C16.0003 16.9729 15.9079 17.3079 15.7799 17.6246H17.7555H21.7672C23.2039 17.6246 24.414 16.4171 23.8651 15.0895C23.5328 14.2857 23.0457 13.5555 22.4316 12.9403C21.8175 12.3252 21.0885 11.8372 20.2862 11.5043C19.4839 11.1714 18.6239 11 17.7555 11C16.8871 11 16.0272 11.1714 15.2249 11.5043C14.7837 11.6873 14.3648 11.9172 13.9749 12.1893C14.277 12.3729 14.5554 12.5918 14.8042 12.8403C15.0601 12.6818 15.3289 12.5438 15.6081 12.4279C16.289 12.1454 17.0187 12 17.7555 12C18.4924 12 19.2221 12.1454 19.9029 12.4279C20.5838 12.7104 21.2026 13.1246 21.7239 13.6468Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccount);
export { ForwardRef as ReactComponent };